export default __webpack_public_path__ + "static/media/fuel-sub-meter-icon.142da755.svg";